import { DataProps } from '../../../../../../utils/hooks/useLangData'

export const productImageParseLangs = (data: DataProps | null, field: string) => {
    let result = ''
    if (data) {
        result = JSON.stringify(data[field])
    }
    return result
}